export const paidLinesOf = (list) => {
    if (list === null || list === undefined)
        return [];
    const fromTill = list.payments.map((payment) => ({
        id: payment.id,
        label: payment.direction === 'out'
            ? `${payment.methodName} (estorno)`
            : payment.methodName,
        amount: payment.amount,
        isRefund: payment.direction === 'out',
    }));
    /*
     * As baixas já vêm SEM as estornadas: o servidor as filtra, porque somar uma
     * baixa desfeita cobraria do cliente o que a loja já devolveu.
     */
    const fromTitles = list.settlements.map((settlement) => ({
        id: settlement.id,
        label: settlement.methodName,
        amount: settlement.amount,
        isRefund: false,
    }));
    return [...fromTill, ...fromTitles];
};
//# sourceMappingURL=document-payments.js.map